/** Entidades do nucleo multi-tenant: condominio, unidade, morador, usuario. */
export const RESIDENT_RELATION_LABELS = {
    owner: 'Proprietario',
    tenant: 'Inquilino',
    dependent: 'Dependente',
    employee: 'Funcionario',
};
// ---------------------------------------------------------------------------
// Identidade
// ---------------------------------------------------------------------------
/** Papeis dentro de UM condominio. Usuario global pode ter papeis diferentes em cada. */
export const MEMBERSHIP_ROLES = [
    'owner', // dono da conta / administradora
    'manager', // sindico
    'concierge', // porteiro / recepcao
    'viewer', // consulta
];
export const ROLE_LABELS = {
    owner: 'Administradora',
    manager: 'Sindico',
    concierge: 'Porteiro',
    viewer: 'Consulta',
};
// ---------------------------------------------------------------------------
// Log do condominio
// ---------------------------------------------------------------------------
/**
 * O log deste condominio virou `SystemLogEntry` (em `billing.ts`), a MESMA
 * forma que o backoffice le.
 *
 * A tela do sindico e a da Azko mostram a mesma coisa com recortes diferentes —
 * duas formas de linha significavam dois componentes de lista, e foi assim que
 * as duas telas envelheceram separadas, cada uma resolvendo mal um pedaco.
 */
/**
 * Rotulo legivel de cada acao registrada.
 *
 * O log guarda `porteiro.acesso_cortado` porque codigo estavel e o que permite
 * filtrar e comparar; a tela nao pode mostrar isso. Acao sem rotulo cai no
 * proprio codigo em vez de sumir — log novo aparece feio, e nao invisivel, e
 * feio a gente conserta quando ve.
 *
 * Encomenda NAO entra aqui: ela tem trilha propria em `package_events`, com
 * status e assinatura. Este log e das acoes administrativas do condominio.
 */
const CONDOMINIUM_ACTION_LABELS = {
    'morador.criado': 'Morador cadastrado',
    'morador.unidades_alteradas': 'Vinculo de morador alterado',
    'moradores.importados': 'Moradores importados por planilha',
    'porteiro.criado': 'Conta de porteiro criada',
    'porteiro.editado': 'Porteiro editado',
    'porteiro.senha_redefinida': 'Senha de porteiro redefinida',
    'porteiro.acesso_cortado': 'Acesso de porteiro cortado',
    'porteiro.acesso_liberado': 'Acesso de porteiro liberado',
    'morador.anonimizado': 'Dados pessoais de morador apagados (LGPD)',
    'morador.dados_exportados': 'Dados de morador exportados (LGPD)',
    'armario.criado': 'Lugar de guarda cadastrado',
    'armario.editado': 'Lugar de guarda renomeado',
    'armario.desativado': 'Lugar de guarda desativado',
    'armario.reativado': 'Lugar de guarda reativado',
    'assinatura.troca_solicitada': 'Troca de plano solicitada',
    'assinatura.troca_cancelada': 'Troca de plano cancelada',
};
export function describeCondominiumAction(action) {
    return CONDOMINIUM_ACTION_LABELS[action] ?? action;
}
//# sourceMappingURL=tenancy.js.map